import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ImportTypes = {
  DRAFT: 'draft',
  PUBLISH: 'publish'
};
const ImportTypeInput = ({
  disabled,
  onChange,
  value
}) => {
  const draftOption = /*#__PURE__*/_jsx(RadioInput, {
    checked: value === ImportTypes.DRAFT,
    disabled: disabled,
    onChange: onChange,
    value: ImportTypes.DRAFT,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.importModal.importTypeInput.options.draftV3"
    })
  }, ImportTypes.DRAFT);
  const publishOption = /*#__PURE__*/_jsx(RadioInput, {
    checked: value === ImportTypes.PUBLISH,
    disabled: disabled,
    onChange: onChange,
    value: ImportTypes.PUBLISH,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.importModal.importTypeInput.options.publish"
    })
  }, ImportTypes.PUBLISH);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.importModal.importTypeInput.label"
    }),
    marginBlockStart: "400",
    children: /*#__PURE__*/_jsxs(ToggleGroup, {
      name: "importTypeInput",
      children: [draftOption, publishOption]
    })
  });
};
ImportTypeInput.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOf(Object.values(ImportTypes)).isRequired
};
export default ImportTypeInput;